import { Component, Input } from '@angular/core';

/**
 * One recipe, rendered exactly as the Recipes screen renders it - steps
 * included, since a recipe without its steps is just a sentence.
 *
 * Same arrangement as MemoryCardComponent: the Recipes screen's markup and
 * stylesheet, with actions opt-in so a read-only host shows none.
 */
@Component({
  selector: 'app-recipe-card',
  standalone: false,
  templateUrl: './recipe-card.component.html',
  styleUrls: ['./recipe-card.component.css'],
})
export class RecipeCardComponent {

  @Input() recipe: any;

  /** 1-based position, shown as #n in the card header. */
  @Input() index = 0;

  @Input() showActions = false;

  /** Steps in order. The list arrives unsorted and order carries meaning. */
  get steps(): any[] {
    const steps = this.recipe?.steps;
    if (!Array.isArray(steps)) {
      return [];
    }
    return steps.slice().sort((a: any, b: any) => (a?.order || 0) - (b?.order || 0));
  }
}
